(function () {
  const CHECKBOX_FIELDS = [
    'reason_damaged',
    'reason_low_beam',
    'reason_high_beam',
    'reason_led',
    'reason_hyperflash',
    'reason_moisture',
    'reason_missing'
  ];

  const TEXT_FIELDS = [
    'date',
    'customer_name',
    'email',
    'phone',
    'mailing_street',
    'mailing_city',
    'mailing_state',
    'mailing_zip',
    'place_of_purchase',
    'product_part_number',
    'anzo_order_number',
    'order_other',
    'vehicle_year',
    'vehicle_make',
    'vehicle_model',
    'vehicle_trim',
    'vehicle_vin',
    'aftermarket_lights',
    'name_on_credit_card',
    'billing_street',
    'billing_city',
    'billing_state',
    'billing_zip',
    'credit_card_number',
    'cvc',
    'expiration',
    'printed_name',
    'signature_date'
  ];

  const FIELD_LABELS = {
    date: 'Date',
    customer_name: 'Full Name',
    email: 'Email',
    phone: 'Phone',
    mailing_street: 'Mailing Street',
    mailing_city: 'Mailing City',
    mailing_state: 'Mailing State',
    mailing_zip: 'Mailing ZIP',
    place_of_purchase: 'Place of Purchase',
    product_part_number: 'Product Part Number',
    anzo_order_number: 'Anzo USA Website Order # (4 digits)',
    order_other: 'Other Order Reference',
    reason_damaged: 'Damaged upon arrival',
    reason_low_beam: 'Low beam issue',
    reason_high_beam: 'High beam issue',
    reason_led: 'LED issue',
    reason_hyperflash: 'Hyperflash issue',
    reason_moisture: 'Moisture issue',
    reason_missing: 'Missing parts',
    reason_other: 'Other reason for claim',
    vehicle_year: 'Vehicle Year',
    vehicle_make: 'Vehicle Make',
    vehicle_model: 'Vehicle Model',
    vehicle_trim: 'Vehicle Trim',
    vehicle_vin: 'VIN',
    aftermarket_lights: 'Other aftermarket lights installed (including Anzo USA)?',
    name_on_credit_card: 'Name on Card',
    billing_street: 'Billing Street',
    billing_city: 'Billing City',
    billing_state: 'Billing State',
    billing_zip: 'Billing ZIP',
    credit_card_number: 'Card Number (last 4 only in summary)',
    cvc: 'CVC (not included in summary)',
    expiration: 'Card Expiration',
    printed_name: 'Printed Name',
    signature_date: 'Signature Date'
  };

  function collectFormData(form) {
    const data = {};
    const formData = new FormData(form);

    TEXT_FIELDS.forEach((field) => {
      const value = formData.get(field);
      if (value && String(value).trim() !== '') {
        data[field] = String(value).trim();
      }
    });

    CHECKBOX_FIELDS.forEach((field) => {
      if (formData.get(field)) {
        data[field] = true;
      }
    });

    if (formData.get('reason_other')) {
      data.reason_other = true;
    }

    const reasonOtherDetail = formData.get('reason_other_detail');
    if (reasonOtherDetail && String(reasonOtherDetail).trim() !== '') {
      data.reason_other_detail = String(reasonOtherDetail).trim();
    }

    return data;
  }

  function buildSummary(data) {
    const lines = [];

    TEXT_FIELDS.forEach((field) => {
      if (!data[field]) {
        return;
      }

      if (field === 'credit_card_number') {
        const digits = data[field].replace(/\D/g, '');
        lines.push(`${FIELD_LABELS[field]}: ****${digits.slice(-4)}`);
        return;
      }

      if (field === 'cvc') {
        return;
      }

      lines.push(`${FIELD_LABELS[field] || field}: ${data[field]}`);
    });

    CHECKBOX_FIELDS.forEach((field) => {
      if (data[field]) {
        lines.push((FIELD_LABELS[field] || field) + ': Yes');
      }
    });

    if (data.reason_other) {
      lines.push(
        (FIELD_LABELS.reason_other || 'reason_other') +
          ': ' +
          (data.reason_other_detail || 'Yes')
      );
    }

    return lines.join('\n');
  }

  function sanitizeFileName(name) {
    return (name || 'warranty-claim')
      .replace(/[^a-z0-9-_]+/gi, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase()
      .slice(0, 60);
  }

  function formatDateForPdf(value) {
    if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    const parts = value.split('-');
    return parts[1] + '/' + parts[2] + '/' + parts[0];
  }

  function preparePdfFieldValue(field, value) {
    if (field === 'date' || field === 'signature_date') {
      return formatDateForPdf(value);
    }

    return value;
  }

  async function fillPdf(pdfUrl, data) {
    if (typeof PDFLib === 'undefined') {
      throw new Error('PDF library failed to load. Please refresh and try again.');
    }

    const response = await fetch(pdfUrl);
    if (!response.ok) {
      throw new Error('Unable to load the warranty form PDF. Please try again later.');
    }

    const pdfBytes = await response.arrayBuffer();
    const pdfDoc = await PDFLib.PDFDocument.load(pdfBytes);
    const form = pdfDoc.getForm();

    TEXT_FIELDS.forEach((field) => {
      if (!data[field]) {
        return;
      }
      try {
        form.getTextField(field).setText(preparePdfFieldValue(field, data[field]));
      } catch (error) {
        console.warn('Could not fill text field: ' + field);
      }
    });

    CHECKBOX_FIELDS.forEach((field) => {
      if (!data[field]) {
        return;
      }
      try {
        form.getCheckBox(field).check();
      } catch (error) {
        console.warn('Could not fill checkbox field: ' + field);
      }
    });

    if (data.reason_other_detail) {
      try {
        form.getTextField('reason_other').setText(data.reason_other_detail);
      } catch (error) {
        console.warn('Could not fill reason_other field');
      }
    }

    const font = await pdfDoc.embedFont(PDFLib.StandardFonts.Helvetica);
    form.updateFieldAppearances(font);

    try {
      form.flatten();
    } catch (error) {
      // Flattening is optional if the PDF uses unsupported field types.
    }

    return pdfDoc.save();
  }

  function arrayBufferToBase64(buffer) {
    const bytes = new Uint8Array(buffer);
    let binary = '';
    const chunkSize = 8192;

    for (let i = 0; i < bytes.length; i += chunkSize) {
      const chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, chunk);
    }

    return btoa(binary);
  }

  function downloadPdf(pdfBytes, fileName) {
    const blob = new Blob([pdfBytes], { type: 'application/pdf' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${fileName}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  }

  async function submitClaim(endpointUrl, secret, payload) {
    const response = await fetch(endpointUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-warranty-secret': secret
      },
      body: JSON.stringify(payload)
    });

    const result = await response.json().catch(() => ({}));

    if (!response.ok || !result.success) {
      throw new Error(result.message || 'Unable to submit your warranty claim. Please try again.');
    }
  }

  function showError(root, message) {
    const errorEl = root.querySelector('[data-warranty-error]');
    if (errorEl) {
      errorEl.hidden = false;
      errorEl.textContent = message;
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  function hideError(root) {
    const errorEl = root.querySelector('[data-warranty-error]');
    if (errorEl) {
      errorEl.hidden = true;
      errorEl.textContent = '';
    }
  }

  function showSuccess(root) {
    const instructionsEl = root.querySelector('[data-warranty-instructions]');
    const formWrap = root.querySelector('[data-warranty-form-wrap]');

    if (formWrap) {
      formWrap.hidden = true;
    }

    if (instructionsEl) {
      instructionsEl.hidden = false;
      instructionsEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  }

  function hasReasonSelected(data) {
    if (CHECKBOX_FIELDS.some(function (field) {
      return data[field];
    })) {
      return true;
    }

    return !!data.reason_other;
  }

  function validateFormData(data) {
    if (!data.customer_name || !data.email) {
      return 'Please enter your name and email address.';
    }

    if (!data.phone) {
      return 'Please enter your phone number.';
    }

    if (!data.product_part_number) {
      return 'Please enter the product part number.';
    }

    if (!hasReasonSelected(data)) {
      return 'Please select at least one reason for your claim.';
    }

    if (data.reason_other && !data.reason_other_detail) {
      return 'Please describe the other reason for your claim.';
    }

    if (!data.vehicle_year || !data.vehicle_make || !data.vehicle_model) {
      return 'Please enter your vehicle year, make, and model.';
    }

    if (!data.vehicle_vin) {
      return 'Please enter your vehicle VIN.';
    }

    if (!data.aftermarket_lights) {
      return 'Please answer whether you have other aftermarket lights installed on your vehicle.';
    }

    return null;
  }

  function bindReasonOtherToggle(form) {
    const otherCheckbox = form.querySelector('[data-warranty-reason-other]');
    const otherFieldWrap = form.querySelector('[data-warranty-reason-other-field]');

    if (!otherCheckbox || !otherFieldWrap) {
      return;
    }

    const otherInput = otherFieldWrap.querySelector('input');

    function syncOtherField() {
      const show = otherCheckbox.checked;
      otherFieldWrap.hidden = !show;

      if (otherInput) {
        otherInput.required = show;

        if (!show) {
          otherInput.value = '';
        }
      }
    }

    otherCheckbox.addEventListener('change', syncOtherField);
    syncOtherField();
  }

  function initSection(root) {
    const form = root.querySelector('[data-warranty-form]');
    if (!form) {
      return;
    }

    bindReasonOtherToggle(form);

    const pdfUrl = root.dataset.pdfUrl;
    const submitEndpoint = root.dataset.submitEndpoint;
    const submitSecret = root.dataset.submitSecret;
    const submitButton = form.querySelector('[data-warranty-submit]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      hideError(root);

      const data = collectFormData(form);
      const validationError = validateFormData(data);

      if (validationError) {
        showError(root, validationError);
        return;
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = submitButton.dataset.loadingText || 'Submitting...';
      }

      try {
        const pdfBytes = await fillPdf(pdfUrl, data);
        const fileName = `anzo-warranty-claim-${sanitizeFileName(data.customer_name)}`;

        if (submitEndpoint && submitSecret) {
          await submitClaim(submitEndpoint, submitSecret, {
            secret: submitSecret,
            customer_name: data.customer_name,
            email: data.email,
            phone: data.phone || '',
            summary: buildSummary(data),
            pdf_base64: arrayBufferToBase64(pdfBytes)
          });
        } else {
          throw new Error('Warranty submission is not configured. Please contact support.');
        }

        downloadPdf(pdfBytes, fileName);
        showSuccess(root);
      } catch (error) {
        showError(root, error.message || 'Something went wrong. Please try again.');
      } finally {
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = submitButton.dataset.defaultText || 'Submit Warranty Claim';
        }
      }
    });
  }

  function init() {
    document.querySelectorAll('[data-warranty-claim]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-warranty-claim]');
    if (root) {
      initSection(root);
    }
  });
})();
